'use strict';

//
import React from 'react';
import $, {extend} from 'jquery';
import classnames from 'classnames'

//
import Component from '../core/component';
import Enhance from '../core/enhance';
//
import {uuid} from '../libs/tools'

var animationEnd = 'animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd';

/**
 *
 */
class Popup extends Component {
    state = {
        hash: uuid(),
        showChildren: false
    };

    constructor(props) {
        super(props);
        extend(this.state, props, true);

    }

    /**
     * 在componentWillMount()在挂载发生之前立即被调用。
     */
    componentWillMount() {
        this._on('popstate', this.handlerPopstate);
    }


    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        this._un('popstate', this.handlerPopstate);
    }


    /**
     * componentDidUpdate(object prevProps, object prevState)在更新发生之后调用。
     */
    componentDidUpdate(prevProps, prevState) {
    }

    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        extend(this.state, nextProps, true);
    }


    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        //动画事件
        $(this.refs.animated).on(animationEnd, this.animationEnd);
    }

    /**
     *
     * @returns {XML}
     */
    render() {
        if (this.state.showChildren)
            return (
                <div className="c-popup">
                    <div ref="popup" className={classnames("popup", this.state.show ? 'modal-in' : 'modal-out')}
                         style={{display: 'block'}}>
                        {this.state.children}
                    </div>
                    <div ref="overlay"
                         className={classnames("popup-overlay", this.state.show ? 'modal-overlay-visible' : '')}></div>
                    <div ref="animated"
                         className={classnames("animated fast", this.state.show ? 'fadeIn' : 'fadeOut')}></div>
                </div>
            );
        else {
            return null;
        }
    }


    handlerPopstate = () => {
        let hash = window.location.hash;
        if ('#' + this.state.hash === hash) {
            this.setState({showChildren: true}, () => {
                this.setState({show: true})
            })
        } else {
            this.setState({show: false})
        }
    }


    /**
     */
    animationEnd = () => {
        console.log('animationEnd');
    }


    /**
     *
     */
    show() {
        window.location.hash = this.state.hash;
    }

    /**
     *
     */
    hide() {
        if ('#' + this.state.hash === window.location.hash) {
            window.history.back();
        }
    }


}

export default Enhance(Popup, {}, 'Popup')